type GetColorRangeReturnType = 0 | 1 | 2;
const markingPoint = process.env.REACT_APP_MARKING_POINT || "1.2";
export const rangeColors = ["red", "orange", "green"];

export const getStrokeColorIndex = (
  _available?: number,
  _threshold?: number
): GetColorRangeReturnType => {
  if (_available == null || _threshold == null) {
    return 0;
  }

  const available = +_available;
  const threshold = +_threshold;
  const range1 = Math.ceil(threshold * +markingPoint);

  return available <= threshold ? 0 : available <= range1 ? 1 : 2;
};

export const getStrokeColor = (available: number, threshold: number) => {
  const range = getStrokeColorIndex(available, threshold);
  return rangeColors[range];
};
